import ApiClientRequest from "../ApiClientRequest";
import BaseApiClientException from "./BaseApiClientException";
import { ApiClientResponse } from "..";

class InternalServerErrorException extends BaseApiClientException {
    static STATUS_CODE = 500;
    constructor(
        request: ApiClientRequest,
        response: ApiClientResponse<unknown>
    ) {
        super(
            "Internal server error",
            InternalServerErrorException.STATUS_CODE,
            request,
            response
        );
    }
}

export default InternalServerErrorException;
